import { Routes } from "@angular/router";

import { RedirectActivationToNewUrl } from "./guards/RedirectActivationToNewUrl";
import { RedirectEventToNewUrl } from "./guards/RedirectEventToNewUrl";
import { SetLanguage } from "./guards/SetLanguage";
import { SetToken } from "./guards/SetToken";
import { OldRoutesRedirector } from "./guards/oldRoutesRedirector";
import { ActivationResolver } from "./resolvers/activationResolver";
import { FormResolver } from "./resolvers/formResolver";
import { SubmissionsResolver } from "./resolvers/submissionResolver";

// support old routes
//   For new submissions
//   #/event/5566/37261e6e41d3398ccb66fddeb4543084/submit
//   #/event/5566/37261e6e41d3398ccb66fddeb4543084/submit-station:1278
export const routes: Routes = [
    // // *****  FOR TESTING  ******
    // {
    //     path: "submissions",
    //     // loadChildren: () => import("./pages/test/submissions/submissions.page").then((m) => m.SubmissionsPageModule),
    //     canActivate: [SetToken, SetLanguage],
    //     resolve: {
    //         form: FormResolver,
    //     },
    //     component: SubmissionsPage,
    // },
    // **************************
    {
        path: "capture/submission",
        canActivate: [SetToken, SetLanguage],
        resolve: {
            form: FormResolver,
            submission: SubmissionsResolver,
        },
        runGuardsAndResolvers: "paramsOrQueryParamsChange",
        loadComponent: () => import("./pages/capture/capture.page").then((m) => m.CapturePage),
    },
    {
        path: "capture/event",
        children: [
            {
                path: "**",
                canActivate: [RedirectEventToNewUrl],
                loadComponent: () => import("./pages/capture/capture.page").then((m) => m.CapturePage),
            },
        ],
    },
    {
        path: "capture/activation",
        children: [
            {
                path: "",
                pathMatch: "full",
                canActivate: [SetToken],
                resolve: {
                    activation: ActivationResolver,
                    submission: SubmissionsResolver,
                },
                loadComponent: () =>
                    import("./pages/capture-activation/capture-activation.page").then((m) => m.CaptureActivationPage),
            },
            {
                path: "**",
                canActivate: [RedirectActivationToNewUrl],
                loadComponent: () =>
                    import("./pages/capture-activation/capture-activation.page").then((m) => m.CaptureActivationPage),
            },
        ],
    },
    {
        path: "screen-saver",
        loadComponent: () => import("./pages/screen-saver/screen-saver.page").then((m) => m.ScreenSaverPage),
    },
    {
        path: "stations",
        loadComponent: () => import("./pages/stations/stations.page").then((m) => m.StationsPage),
    },

    {
        path: "search",
        loadComponent: () => import("./pages/search/search.page").then((m) => m.SearchPage),
    },

    {
        path: "activation-element",
        loadComponent: () =>
            import("./pages/activation-element/activation-element.page").then((m) => m.ActivationElementPage),
    },
    {
        path: "scanner-settings",
        loadComponent: () =>
            import("./pages/scanner-settings/scanner-settings.page").then((m) => m.ScannerSettingsPage),
    },

    {
        path: "documents",
        loadComponent: () => import("./pages/documents/documents.page").then((m) => m.DocumentsPage),
    },
    {
        path: "signature",
        loadComponent: () => import("./pages/signature/signature.page").then((m) => m.SignaturePage),
    },
    {
        path: "goc-camera",
        loadComponent: () => import("./pages/goc-camera/goc-camera.page").then((m) => m.GocCameraPage),
    },
    {
        path: "image-preview",
        loadComponent: () => import("./pages/image-preview/image-preview.page").then((m) => m.ImagePreviewPage),
    },
    {
        path: "game",
        loadComponent: () => import("./pages/game/game.page").then((m) => m.GamePage),
    },
    {
        path: "goc-barcode-scanner",
        loadComponent: () =>
            import("./pages/goc-barcode-scanner/goc-barcode-scanner.page").then((m) => m.GocBarcodeScannerPage),
    },

    {
        path: "meeting-automation",
        loadComponent: () =>
            import("./pages/meeting-automation/meeting-automation.page").then((m) => m.MeetingAutomationPage),
    },
    {
        path: "submission-actions",
        loadComponent: () =>
            import("./pages/submission-actions/submission-actions.page").then((m) => m.SubmissionActionsPage),
    },

    {
        path: "nfcscan",
        loadComponent: () => import("./pages/nfcscan/nfcscan.page").then((m) => m.NFCscanPage),
    },
    {
        path: "iframe-container",
        loadComponent: () =>
            import("./pages/iframe-container/iframe-container.page").then((m) => m.IframeContainerPage),
    },
    {
        path: "users-selection",
        loadComponent: () => import("./pages/users-selection/users-selection.page").then((m) => m.UsersSelectionPage),
    },
    {
        path: "success",
        loadComponent: () => import("./pages/html-message/html-message.page").then((m) => m.HtmlMessagePage),
    },
    {
        path: "html5-qrcode",
        loadComponent: () => import("./pages/html5-qrcode/html5-qrcode.page").then((m) => m.Html5QrcodePage),
    },
    {
        path: "lookups-verifications",
        loadComponent: () =>
            import("./pages/lookups-verifications/lookups-verifications.page").then((m) => m.LookupsVerificationsPage),
    },
    {
        path: "**",
        canActivate: [OldRoutesRedirector],
        loadComponent: () => import("./pages/not-found/not-found.page").then((m) => m.NotFoundPage),
    },
    {
        path: "handheld-scanner",
        loadComponent: () =>
            import("./pages/handheld-scanner/handheld-scanner.page").then((m) => m.HandheldScannerPage),
    },
    {
        path: "selfie-camera",
        loadComponent: () => import("./pages/selfie-camera/selfie-camera.page").then((m) => m.SelfieCameraPage),
    },
    {
        path: "lookups-verifications",
        loadComponent: () =>
            import("./pages/lookups-verifications/lookups-verifications.page").then((m) => m.LookupsVerificationsPage),
    },
];
